import { Spinner } from 'react-bootstrap';

const Loader = () => {
  return (
    <div className='d-flex justify-content-center align-items-center py-4'>
      <Spinner
        animation='border'
        role='status'
        style={{
          width: '3rem',
          height: '3rem',
          borderWidth: '3px',
          color: 'var(--primary-600)',
        }}
      >
        <span className='visually-hidden'>Loading...</span>
      </Spinner>
    </div>
  );
};

export default Loader;
